<template>
  <div>
    <Navbar/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idMotivo" class="form-label">IdMotivo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMotivo" name="idMotivo" v-model="datoMotivo.idMotivo" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoMotivo.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarMotivo" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditMotivo" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdAtencion</th>
          <th scope="col">IdPersona</th>
          <th scope="col">IdMedico</th>
          <th scope="col">IdCita</th>
          <th scope="col">Observación</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaAct</th>
          <th scope="col">Estado</th>
          <th scope="col">CitaFechaReg</th>
          <th scope="col">PersonaFechaReg</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="atencion in datosPaginados" :key="atencion.idAtencion">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(atencion.idAtencion)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(atencion.idAtencion)" title="Editar">edit_square</i></td>
          <td>{{atencion.idAtencion}}</td>
          <td>{{atencion.idPersona}}</td>
          <td>{{atencion.idMedico}}</td>
          <td>{{atencion.idCita}}</td>
          <td>{{atencion.observacion}}</td>
          <td>{{getFormattedDate(atencion.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(atencion.fechaAct, 'DD/MM/YYYY')}}</td>
          <td>{{atencion.estado}}</td>
          <td>{{getFormattedDate(atencion.citaFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(atencion.personaFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteMotivo(atencion.idAtencion)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idAtencion" class="form-label">IdAtencion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAtencion" name="idAtencion" v-model="datoAtencion.idAtencion" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idEmpresa" class="form-label"> Empresa</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoAtencion.idEmpresa">
                      <option v-for="empresa in empresas" :value="empresa.idEmpresa" :key="empresa.idEmpresa">
                        {{ empresa.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPersona" name="idPersona" v-model="datoAtencion.idPersona">
                      <option v-for="persona in personas" :value="persona.idPersona" :key="persona.idPersona">
                        {{ persona.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idMedico" class="form-label"> Medico</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idMedico" name="idMedico" v-model="datoAtencion.idMedico">
                      <option v-for="medico in medicos" :value="medico.idMedico" :key="medico.idMedico">
                        {{ medico.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idCita" class="form-label"> Cita</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idCita" name="idCita" v-model="datoAtencion.idCita">
                      <option v-for="cita in citas" :value="cita.idCita" :key="cita.idCita">
                        {{ cita.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idFactura" class="form-label"> Factura</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idFactura" name="idFactura" v-model="datoAtencion.idFactura">
                      <option v-for="factura in facturas" :value="factura.idFactura" :key="factura.idFactura">
                        {{ factura.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idAsiento" class="form-label"> Asiento</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAsiento" name="idAsiento" v-model="datoAtencion.idAsiento">
                      <option v-for="asiento in asientos" :value="asiento.idAsiento" :key="asiento.idAsiento">
                        {{ asiento.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg" v-model="datoAtencion.idUsuarioReg" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct" v-model="datoAtencion.idUsuarioAct" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoAtencion.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoAtencion.fechaAct" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoAtencion.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idMotivo" class="form-label">IdMotivo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMotivo" name="idMotivo" v-model="datoAtencion.idMotivo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarAtencion" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAtencion" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      motivos : [],
      datoMotivo : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idMotivo: '',
// Variables master
// Variables details
      atencions : [],
      datoAtencion : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      personas : [],
      medicos : [],
      citas : [],
      facturas : [],
      asientos : [],
//      motivos : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idMotivo = this.$route.params.p_idmotivo
    this.abrirEditar(this.p_idMotivo)
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'nombre'
      ];
      const requiredFieldsText = [
        'nombre'
      ];
      return validarForm(this.datoMotivo, requiredFields, requiredFieldsText);
    },
    async guardarMotivo(){
      if(this.validarForm() === 1){
        try {
          await api.post('/motivos', this.datoMotivo)
          swal("Correcto!", "Motivo creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditMotivo(){
      if(this.validarForm() === 1){
        try {
          await api.post('/motivos', this.datoMotivo)
          swal("Correcto!", "Motivo creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoMotivo={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idMotivo){
      this.modalWindow = true
      if(idMotivo != null){    
           api.get('/vwmotivos/'+idMotivo).then(resp=>{
          this.datoMotivo = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarMotivo(){
      this.$router.push('/Motivo')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.atencions.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwatencions/nombre/'+this.nombreBusqueda).then(response=>{
          this.atencions=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.atencions.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwatencions').then(response=>{
      this.atencions=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.atencions.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'nombre'
      ];
      const requiredFieldsText = [
        'nombre'
      ];
      return validarForm(this.datoMotivo, requiredFields, requiredFieldsText);
    },
    async guardarAtencion(){
      if(this.validarForm() === 1){
        try {
          this.datoAtencion.idMotivo = this.datoMotivo.idMotivo;
          await api.post('/atencions', this.datoAtencion)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Atencion creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAtencion(){
      if(this.validarForm() === 1){
        try {
          await api.post('/atencions', this.datoAtencion)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Atencion creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoAtencion={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idAtencion){
      this.modalWindow = true
      if(idAtencion != null){    
           api.get('/vwatencions/'+idAtencion).then(resp=>{
          this.datoAtencion = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idAtencion){
      this.modalWindow = true
      if(idAtencion != null){
        this.$router.push('/atencionmd/'+idAtencion)
      }
    },
    async deleteAtencion (idAtencion) {
      try{
        await api.delete('/atencions/'+idAtencion)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchPersonas() {
      fetch('http://localhost:8080/api/v1/personas')
        .then(response => response.json())
        .then(data => {
          this.personas = data;
        })
        .catch(error => {
          console.error('Error fetching personas:', error);
        });
    },
    fetchMedicos() {
      fetch('http://localhost:8080/api/v1/medicos')
        .then(response => response.json())
        .then(data => {
          this.medicos = data;
        })
        .catch(error => {
          console.error('Error fetching medicos:', error);
        });
    },
    fetchCitas() {
      fetch('http://localhost:8080/api/v1/citas')
        .then(response => response.json())
        .then(data => {
          this.citas = data;
        })
        .catch(error => {
          console.error('Error fetching citas:', error);
        });
    },
    fetchFacturas() {
      fetch('http://localhost:8080/api/v1/facturas')
        .then(response => response.json())
        .then(data => {
          this.facturas = data;
        })
        .catch(error => {
          console.error('Error fetching facturas:', error);
        });
    },
    fetchAsientos() {
      fetch('http://localhost:8080/api/v1/asientos')
        .then(response => response.json())
        .then(data => {
          this.asientos = data;
        })
        .catch(error => {
          console.error('Error fetching asientos:', error);
        });
    },
/*     fetchMotivos() {
      fetch('http://localhost:8080/api/v1/motivos')
        .then(response => response.json())
        .then(data => {
          this.motivos = data;
        })
        .catch(error => {
          console.error('Error fetching motivos:', error);
        });
    }, */
  },
}
</script>
